import React, { useEffect, useState } from "react";
import "./Store.css";
import storedata from './Store/Aeonix.Store.json';
const handleBuy = async (code) => {
  // Display an error message instead of initiating a Stripe session
  window.alert('Functionality removed');
};

function Store() {
  const [storeItems, setStoreItems] = useState([]);
  const [sortedBy, setSortedBy] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');

  useEffect(() => {
    async function getItems() {
      // Dummy data for store items since backend is removed
      

      setStoreItems(storedata);
    }

    getItems();
  }, []);

  const sortItems = (criteria) => {
    const sortedItems = [...storeItems];
    let newSortDirection = 'asc';

    if (criteria === sortedBy) {
      // If already sorted by the same criteria, toggle the sort direction
      newSortDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    }

    if (criteria === 'name') {
      sortedItems.sort((a, b) => {
        const compareResult = a.name.localeCompare(b.name);
        return newSortDirection === 'asc' ? compareResult : -compareResult;
      });
    } else if (criteria === 'price') {
      sortedItems.sort((a, b) => {
        const compareResult = a.price - b.price;
        return newSortDirection === 'asc' ? compareResult : -compareResult;
      });
    }

    setStoreItems(sortedItems);
    setSortedBy(criteria);
    setSortDirection(newSortDirection);
  };

  return (
    <div className="store">
      <h1>Welcome to AEONIX Store</h1>
      <div id="remote">
        <button onClick={() => sortItems('name')}>
          Sort by Name {sortedBy === 'name' && `(${sortDirection})`}
        </button>
        <button onClick={() => sortItems('price')}>
          Sort by Price {sortedBy === 'price' && `(${sortDirection})`}
        </button>
      </div>
      <div className="store-items">
        <div className="row">
          {storeItems.map((item) => (
            <div className="col" key={item.id}>
              <div className="card">
                <img src={item.image} alt={item.name} />
                <h3>{item.name}</h3>
                <p>${item.price}</p>
                <button onClick={() => handleBuy(item.id)}>
                  Buy now
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Store;
